import { roundOffPrecicion } from "../../../utils/quantityConversion";

export const ConsumptionTable = ({
    title,
    data,
    unitVariations,
    sortEntriesByKeyAsc,
    handleFetchDetails,
    category,
}) => {
    return (
        <div className="border p-2">
            <div className="font-semibold mb-1.5 text-sm text-center tracking-wider">{title}</div>

            <div className="rounded-md border overflow-x-auto tiny-scrollbar max-h-[420px]">
                <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-xs text-center">
                    <thead className="bg-gray-100 top-0 z-10 sticky">
                        <tr>
                            <th className="px-1 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Item</th>
                            <th className="px-1 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">Amount</th>
                            <th className="px-1 py-2 text-xs font-medium text-gray-700 uppercase tracking-wider">UOM</th>
                        </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-100">
                        {data && Object.keys(data).length > 0 ? (

                            sortEntriesByKeyAsc(data)
                                .map(([item, details], index) => {
                                    return (
                                        <tr
                                            key={index}
                                            className={`${details?.is_standard_uom === false
                                                ? 'bg-amber-50 text-amber-500'
                                                : ''
                                                }`}
                                        >
                                            <td
                                                className="px-2 py-1 hover:cursor-pointer hover:underline tracking-wide"
                                                onClick={() => handleFetchDetails(item, category)}
                                            >
                                                {item}
                                            </td>
                                            <td className="px-2 py-1 tracking-wide">{roundOffPrecicion(details.converted_secondary_quantity)}</td>
                                            <td className="px-2 py-1 tracking-wide">
                                                {details?.secondary_unit || details?.uom}
                                            </td>
                                        </tr>
                                    );
                                })

                        ) : (
                            <tr>
                                <td colSpan={3} className="px-3 py-4 text-gray-500">
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};